import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "upload-button-area" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-icon_tianjia" }),
  /*#__PURE__*/_createElementVNode("span", null, "上传图片")
], -1)

import { ElMessage, UploadFile, UploadProps } from "element-plus";
import _ from "lodash";
import { reactive, getCurrentInstance, ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const { proxy } = getCurrentInstance() as any;
const validateImage = (rule: any, value: any, callback: any) => {
  if (!value || !value.length) {
    callback(new Error("请上传图片"));
  } else {
    callback();
  }
};
const masFormMainRef = ref<any>(null);
const masUploadRef = ref<any>(null);
const state: any = reactive({
  uploadAccept: ".jpg,.png",
  dialog: false,
  title: "",
  form: {
    enclosureId: "",
    name: "",
    list: [],
  },
  ruleForm: {
    list: [{ required: true, validator: validateImage, trigger: "blur" }],
  },
  type: "image",
});
const remove = () => {
  state.form.list = [];
};
const active = (res: any, type: number) => {
  state.dialog = true;

  state.title = `${type === 1 ? "添加" : "编辑"}图片`;
  // id作为是否编辑的依据
  if (!res.enclosureId) {
    setTimeout(() => {
      state.form = { ...res };
      state.form.enclosureId = "";
      masFormMainRef.value._resetForm();
    }, 50);
  } else {
    setTimeout(() => {
      state.form = { ...res };
      masUploadRef.value.setFileList(res);
    }, 100);
  }
};

const beforeUpload: UploadProps['beforeUpload'] = (rawFile) => {
  if (rawFile.type === "image/jpeg" || rawFile.type === "image/png") {
    if (rawFile.size / 1024 / 1024 > 10) {
      ElMessage.error("图片大小需要小于 10M!");
      return false;
    }
  }
  return true;
};

const confimForm = (res: any) => {
  // enclosureId : 附件id 作为编辑附件的唯一凭据
  state.dialog = false;
  state.form.enclosureId = state.form.enclosureId;
  state.form.name = "图片";
  let linkData = [
    {
      ...state.form,
    },
  ];
  proxy.$emit("updateSuccess", linkData, state.type);
};
expose({
  active,
});

return (_ctx: any,_cache: any) => {
  const _component_mas_upload = _resolveComponent("mas-upload")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_mas_form_main = _resolveComponent("mas-form-main")!
  const _component_mas_modal = _resolveComponent("mas-modal")!

  return (_openBlock(), _createBlock(_component_mas_modal, {
    visible: _unref(state).dialog,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).dialog) = $event)),
    customFooterBtns: "",
    closeIcon: "",
    width: "600px",
    title: _unref(state).title
  }, {
    content: _withCtx(() => [
      _createVNode(_component_mas_form_main, {
        ref_key: "masFormMainRef",
        ref: masFormMainRef,
        form: _unref(state).form,
        ruleForm: _unref(state).ruleForm,
        defaultFormFooterButton: ['confirm', 'cancel'],
        onConfim: confimForm,
        labelWidth: "100px",
        onCancel: _cache[0] || (_cache[0] = ($event: any) => (_unref(state).dialog = false))
      }, {
        content: _withCtx((slotProps) => [
          _createVNode(_component_el_form_item, {
            label: "图片",
            prop: "list",
            style: {"width":"calc(100% - 100px)"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_mas_upload, {
                ref_key: "masUploadRef",
                ref: masUploadRef,
                accept: _unref(state).uploadAccept,
                customCon: true,
                value: slotProps.content.list,
                "onUpdate:value": ($event: any) => ((slotProps.content.list) = $event),
                onRemove: remove,
                action: `/api/resource/upload?type=image`,
                drag: true,
                "before-upload": beforeUpload,
                tip: "建议图片为 jpg/png 格式，大小在10M以内"
              }, {
                content: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 2
              }, 1032, ["accept", "value", "onUpdate:value"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["form", "ruleForm"])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})